<template>
  <div class="step-update-credential">
    <div class="newPassWord" v-if="changeType === 'password'">
      <el-form
        ref="passwordElForm"
        :rules="formRules"
        :model="newPassword"
        label-width="auto"
      >
        <el-form-item :label="$fanyi('新密码') + '：'" prop="one">
          <el-input v-model="newPassword.one" show-password class="uiInput" />
        </el-form-item>
        <el-form-item :label="$fanyi('再次确认密码') + '：'" prop="two">
          <el-input v-model="newPassword.two" show-password class="uiInput" />
        </el-form-item>
      </el-form>

      <el-button class="uiBtn nextBtn" @click="handlePasswordSubmit">
        {{ $fanyi("下一步") }}
      </el-button>
    </div>

    <div class="newemail" v-else>
      <el-form
        ref="emailElForm"
        :rules="formRules"
        :model="newEmail"
        label-width="auto"
      >
        <el-form-item
          :label="$fanyi('国家') + '：'"
          :prop="changeType === 'email' ? 'emailone' : 'mobileone'"
          v-if="changeType === 'mobile'"
        >
          <el-select
            v-model="country"
            filterable
            placeholder=""
            class="uiSelect"
          >
            <el-option
              v-for="item in countryAndAreaCode"
              :key="item.value"
              :label="item.sxval || item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="
            (changeType === 'mobile' ? $fanyi('手机') : $fanyi('邮箱')) + '：'
          "
          :prop="changeType === 'email' ? 'emailone' : 'mobileone'"
        >
          <el-input v-model="newEmail.email" class="uiInput" />
        </el-form-item>
        <el-form-item :label="$fanyi('验证码') + '：'" prop="checktwo">
          <div class="checkBox">
            <el-input v-model="newEmail.regCode" class="uiInput" />
            <el-button
              class="uiBtn uiGreen"
              v-if="showBtn"
              @click.prevent="sendEmailCode"
            >
              {{ $fanyi("验证码获取") }}
            </el-button>
            <el-button
              v-else
              class="uiBtn sixSec uiGreen"
              style="opacity: 0.3"
              @click.prevent
            >
              {{ Countdown }} S
            </el-button>
          </div>
        </el-form-item>
      </el-form>

      <el-button class="uiBtn nextBtn" @click="handleEmailNext">
        {{ $fanyi("下一步") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import allImportData from "@/utlis/allImportData.js";
export default {
  name: "StepUpdateCredential",
  props: {
    changeType: { type: String, required: true },
    identity: { type: Object, required: true },
    verificationNumber: { type: String, default: "" },
    loginName: { type: String, default: "" },
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fanyi("请再次输入密码")));
      } else if (value !== this.newPassword.one) {
        callback(new Error(this.$fanyi("您输入的密码不一致！")));
      } else {
        callback();
      }
    };
    return {
      countryAndAreaCode: allImportData.countryAndAreaCode || [],
      newPassword: {
        one: "",
        two: "",
      },
      newEmail: {
        email: "",
        regCode: "",
      },
      country: this.$store.state.userInfo.country_phone || "+39",
      showBtn: true,
      Countdown: 60,
      codeTimer: null,
      formRules: {
        one: [
          {
            required: true,
            pattern: /^.{6,}$/,
            message: this.$fanyi("密码至少6位。"),
          },
        ],
        two: [
          {
            required: true,
            validator: validatePass2,
          },
        ],
        checktwo: [],
        mobileone: [],
        emailone: [],
      },
    };
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    getModifyOccasion() {
      const map = {
        email: "modify_email",
        mobile: "modify_mobile",
        password: "modify_password",
      };
      return map[this.changeType] || "modify_password";
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
    },
    sendEmailCode() {
      if (!this.newEmail.email) {
        return this.$message(this.$fanyi("必填参数缺失"));
      }
      var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (
        this.changeType == "email" &&
        !emailRegExp.test(this.newEmail.email)
      ) {
        return this.$message(this.$fanyi("请输入正确的邮箱地址"));
      }

      let datas = {
        occasion: this.getModifyOccasion(),
        tool: this.changeType,
        number: this.newEmail.email,
        login_name: this.loginName,
      };
      if (this.changeType == "mobile") {
        datas.area_code = this.country;
      }
      this.showBtn = false;
      this.Countdown = 60;
      this.clearCodeTimer();
      this.$api.sendVerificationCode(datas).then((res) => {
        this.showBtn = true;
        if (res.code != 0) return this.$message.error(this.$fanyi("操作失败"));
        this.showBtn = false;
        this.Countdown = 60;
        this.codeTimer = setInterval(() => {
          this.Countdown--;
          if (this.Countdown <= 0) {
            this.showBtn = true;
            this.Countdown = 60;
            this.clearCodeTimer();
          }
        }, 1000);
      });
    },
    checkNewContactVerification(done) {
      let datas = {
        occasion: this.getModifyOccasion(),
        number: this.newEmail.email,
        code: this.newEmail.regCode,
      };
      if (this.changeType == "mobile") {
        datas.area_code = this.country;
      }
      if (!datas.number) {
        return this.$message(this.$fanyi("重要参数为空"));
      }
      this.$api.checkVerificationCode(datas).then((res) => {
        if (res.success == true) {
          done();
        } else {
          this.$message.warning(this.$fanyi("验证码错误"));
        }
      });
    },
    changeEmailNext() {
      if (!this.newEmail.email || !this.newEmail.regCode) {
        return this.$message(this.$fanyi("必填参数缺失"));
      }
      var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (
        this.changeType == "email" &&
        !emailRegExp.test(this.newEmail.email)
      ) {
        return this.$message(this.$fanyi("请输入正确的邮箱地址"));
      }
      this.checkNewContactVerification(() => {
        if (this.changeType == "mobile") {
          this.$api
            .userMobileSave({
              mobile: this.newEmail.email,
              oldpassword: this.identity.oldPassword,
              verification: {
                number: this.newEmail.email,
                code: this.newEmail.regCode,
              },
            })
            .then((res) => {
              if (res.code != 0)
                return this.$message.error(this.$fanyi(res.msg));
              this.$emit("complete");
            });
        }
        if (this.changeType == "email") {
          this.$api
            .userEmailSave({
              email: this.newEmail.email,
              oldpassword: this.identity.oldPassword,
              verification: {
                number: this.newEmail.email,
                code: this.newEmail.regCode,
              },
            })
            .then((res) => {
              if (res.code != 0)
                return this.$message.error(this.$fanyi("ya está en uso"));
              this.$emit("complete");
            });
        }
      });
    },
    changePassword() {
      let datas = {
        password: this.newPassword.one,
        oldpassword: this.identity.oldPassword,
        verification: {
          number: this.verificationNumber,
          code: this.identity.regCode,
        },
      };
      this.$api.userPasswordSave(datas).then((res) => {
        if (res.success == true) {
          this.$emit("complete");
        } else {
          this.$message.error(this.$fanyi("操作失败"));
        }
      });
    },
    handlePasswordSubmit() {
      this.$refs.passwordElForm.validate((valid) => {
        if (valid) this.changePassword();
      });
    },
    handleEmailNext() {
      this.changeEmailNext();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/css/mixin.scss";

.step-update-credential {
  padding-top: 40px;
  .newemail {
    .checkBox {
      display: flex;
      .el-button {
        margin-left: 16px;
      }
    }
  }
  .el-form {
    margin-bottom: 40px;
  }
  .el-input {
    width: 400px;
    height: 40px;
  }
  /deep/ .uiInput .el-input__inner {
    height: 40px;
    line-height: 40px;
  }
  .uiSelect {
    width: 400px;
    height: 40px;
  }
}
</style>
